import constants from '#packages/constants';
import { SectionsApiKey } from '#packages/apis';
import * as util from '#packages/util';
import * as coreBi from '#packages/coreBi';
const columnsEvents = coreBi.events.columns;

import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef } from 'types/documentServices';

function getAddColumnBIParams(
  editorAPI: EditorAPI,
  compRef: CompRef,
  origin: string,
): any {
  const containerRef = editorAPI.components.getContainer(compRef);
  const component_id = compRef?.id;
  const parent_component_id = containerRef?.id;

  return {
    num_of_columns_before:
      editorAPI.components.getChildren(containerRef).length - 1,
    origin,
    component_id,
    parent_component_id,
  };
}

function sendAddColumnBI(
  editorAPI: EditorAPI,
  compRef: CompRef,
  origin: string,
) {
  const sectionsAPI = editorAPI.host.getAPI(SectionsApiKey);
  const biParams = getAddColumnBIParams(editorAPI, compRef, origin);
  const containerRef = editorAPI.components.getContainer(compRef);
  const target_component = editorAPI.components.getType(containerRef);
  editorAPI.bi.event(columnsEvents.COLUMNS_ADD_COLUMN_CLICK, biParams);

  editorAPI.bi.event(
    coreBi.events.addPanel.COMPONENT_ADDED_TO_STAGE,
    Object.assign({
      ...editorAPI.bi.getComponentsBIParams([compRef])[0],
      origin,
      component_id: compRef.id,
      component_name: constants.COMP_TYPES.COLUMN,
      adding_method: 'click',
      page_id: editorAPI.pages.getFocusedPageId(),
      target_component,
      target_component_id: containerRef?.id,
      non_page_top_parent_component_id: util.sections.isSectionsEnabled()
        ? sectionsAPI.getFocusedSection()?.id
        : editorAPI.pages.getFocusedPage().id,
    }),
  );
}

export { sendAddColumnBI };
